import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { CatalogItem } from '../types/catalogItem';
import type { TrialDescription } from '../types/trial';

export interface TrialState {
  loading: boolean;
  initialized: boolean;
  description: TrialDescription | null;
  trialCatalog: CatalogItem | null;
  sourceCatalog: CatalogItem | null;
}

const initialState: TrialState = {
  loading: false,
  initialized: false,
  description: null,
  trialCatalog: null,
  sourceCatalog: null,
};

const trialSlice = createSlice({
  name: 'trial',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setInitialized(state, action: PayloadAction<boolean>) {
      state.initialized = action.payload;
    },
    setDescription(state, action: PayloadAction<TrialDescription | null>) {
      state.description = action.payload;
    },
    setTrialCatalog(state, action: PayloadAction<CatalogItem | null>) {
      state.trialCatalog = action.payload;
    },
    setSourceCatalog(state, action: PayloadAction<CatalogItem | null>) {
      state.sourceCatalog = action.payload;
    },
    resetTrial() {
      return initialState;
    },
  },
});

export const {
  setLoading,
  setInitialized,
  setDescription,
  setTrialCatalog,
  setSourceCatalog,
  resetTrial,
} = trialSlice.actions;

export default trialSlice.reducer;
